export default __webpack_public_path__ + "static/media/cats.0c72edc1.svg";